import React, { forwardRef } from 'react';
import styled from 'styled-components';

// eslint-disable-next-line no-unused-vars
const widthMap = {
  S: '100px',
  M: '260px',
  L: '360px',
  XL: '400px',
};

const Wrapper = styled.div`
  margin-bottom: ${({ removeMargin }) => (removeMargin ? '0' : '10px')};
  max-width: 100%;
  ${({ themeConfiguration }) =>
    themeConfiguration &&
    `
		color: ${themeConfiguration.color};
	`}
  .radio-group-wrapper > label > input {
    &:checked ~ div.cb_wrapper {
      background: #18355e;
    }
  }
  @media (forced-colors: active) {
    ${({ shape }) =>
      shape === 'rectangle' &&
      `
		  .radio-group-wrapper > label > input {
			&:checked ~ span[name="label-text"] {
			  background: Highlight;
			  color: WindowText;
			  border: 1px solid WindowText;
			  forced-color-adjust: none;
			}
			&:checked:focus ~ span[name="label-text"] {
			  background: Highlight;
			  color: WindowText;
			  outline: 3px solid WindowText;
			  outline-offset: 3px;
			  forced-color-adjust: none;
			  border: none;
			}
		  }
		`}
    ${({ shape }) =>
      shape === 'card_button' &&
      `
		  .radio-group-wrapper > label > input {
			&:checked ~ div.cb_wrapper {
			  background: Highlight;
			}
		  }
		`}
		${({ shape }) =>
      shape === 'classic' &&
      `
		  .radio-group-wrapper > label > input {
			& ~ span[name="fake-input"] {
			  background: Highlight;
			}
			&:checked ~ span[name="fake-input"] {
			  background: Highlight;
			  &:after {
				background: WindowText;
			  }
			}
		  }
		`}
  }
`;

const SelectWrapper = forwardRef(({ width, themeConfiguration, children, shape, onBlur }, ref) => {
  const handleBlur = (e) => {
    if (onBlur) {
      onBlur(e, ref);
    }
  };
  return (
    <Wrapper
      name='select-wrapper'
      width={ width }
      themeConfiguration={ themeConfiguration }
      shape={ shape }
      onBlur={ handleBlur }
      ref={ ref }
    >
      {children}
    </Wrapper>
  );
});

export const TooltipWrapper = styled.div`
  display: ${({ hideTooltipWrapper }) => (hideTooltipWrapper ? 'none' : 'flex')};
  align-items: center;
  &div: first-child {
    padding: 0.5em;
    padding-left: 0px;
  }
  & div {
    margin-right: 10px;
    margin-bottom: 5px;
  }
`;

export default SelectWrapper;
